






























































































































































































import { CreateGroupLicenseDTO } from '@/jbi-shared/dto/jaas-groups.dtos';
import {
  CourseDetails,
  CourseLicensePreviewObject,
  CourseLicensePreviewRequestDTO,
  CourseLicenseTemplateResponse,
  UpdateCourseStatusDTO
} from '@/jbi-shared/dto/jtms.dtos';
import {
  AttributeValueType,
  GroupLevelAttributeOption,
  GroupLevelAttributeValue
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { CourseStatus, CourseVisibility } from '@/jbi-shared/types/jtms.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { formatDateTime } from '@/jbi-shared/util/group-level-attributes.util';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import BaseDivider from '@/jbi-shared/vue-components/BaseDivider.vue';
import { GroupDetail } from '@/store/modules/admin/types/admin.types';
import { LocationType } from '@/store/modules/admin/types/group-level-attribute.types';
import { CreateGroupLicenseRequestPayload } from '@/store/modules/admin/types/group-license.types';
import { CoursePackageComponent } from '@/store/modules/jtms/course-package/course-package.types';
import { CourseRegistrationConfig } from '@/store/modules/jtms/course/course.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import dayjs from 'dayjs';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import CourseCancellationConfirmationModal from './comfirmation-modals/CourseCancellationConfirmationModal.vue';
import DisableCoursePackagesModal from './comfirmation-modals/DisableCoursePackagesModal.vue';
import LicenseExceedsCourseSizeConfirmationModal from './comfirmation-modals/LicenseExceedsCourseSizeConfirmationModal.vue';
import CourseLicenseForm from './CourseLicenseForm.vue';
import PublishRegistrationStatusSelection from './PublishRegistrationStatusSelection.vue';
import PublishVisibilityDropdown from './PublishVisibilityDropdown.vue';
import IncompleteCourseDetailsWarning from './static-info-box/IncompleteCourseDetailsWarning.vue';

@Component({
  components: {
    BaseDivider,
    BaseButton,
    PublishVisibilityDropdown,
    PublishRegistrationStatusSelection,
    CourseLicenseForm,
    IncompleteCourseDetailsWarning
  }
})
export default class PublishDraftCourseModal extends Vue {
  @Prop() attributes!: GroupLevelAttributeValue[];
  @Prop({ default: CourseVisibility.PRIVATE }) visibility!: CourseVisibility;
  @Prop() courseStatus!: CourseStatus;
  @Prop({ default: false }) openForRegistration!: boolean;
  @Prop({ default: true }) requireRegistrationConfirmation!: boolean;
  @Prop({ default: false }) groupRegistration!: boolean;
  @Prop({ default: false }) enableQuestionnaire!: boolean;
  @Prop({ default: false }) freeCourse!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) isRegistrationSettings!: boolean;

  @Action('courseLicenseTemplate/generateCourseLicensePreviewFromTemplate')
  generateCourseLicensePreviewFromTemplate!: (
    payload: CourseLicensePreviewRequestDTO
  ) => void;

  @Getter('coursePackage/pricedCoursePackageCount')
  pricedCoursePackageCount!: boolean;

  @Getter('coursePackage/hasPricedCoursePackages')
  hasPricedCoursePackages!: boolean;

  @Getter('course/hasMissingRequiredCourseLevelAttributes')
  hasMissingRequiredCourseLevelAttributes!: boolean;

  @State((state: RootState) => state.courseLicenseTemplate.courseLicensePreview)
  courseLicensePreview!: CourseLicensePreviewObject;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState
        .generateCourseLicensePreviewFromTemplate
  )
  generateCourseLicensePreviewFromTemplateApiState!: ApiState;

  @State(
    (state: RootState) =>
      state.course.courseLicenseState.shouldCreateWithLicense
  )
  shouldCreateWithLicense!: boolean;

  @State(
    (state: RootState) =>
      state.coursePackage.coursePackageTabState.activeCoursePackages
  )
  activeCoursePackages!: CoursePackageComponent[];

  @State((state: RootState) => state.admin.groupDetail)
  groupDetail!: GroupDetail;

  @State((state: RootState) => state.course.courseCreationState.courseSize)
  courseSize!: number;

  @State((state: RootState) => state.course.courseCreationState.courseStartDate)
  courseStartDate!: string;

  @State((state: RootState) => state.course.courseCreationState.courseEndDate)
  courseEndDate!: string;

  @State((state: RootState) => state.course.courseDetails)
  courseDetails!: CourseDetails;

  link: string = '';
  venue: string = '';
  localVisibility: CourseVisibility = CourseVisibility.PRIVATE;
  localOpenForRegistration: boolean = false;
  localRequireRegistrationConfirmation: boolean = false;
  localGroupRegistration: boolean = false;
  localEnableQuestionnaire: boolean = false;
  localFreeCourse: boolean = false;

  createCourseLicensePayload: CreateGroupLicenseDTO | null = null;
  localCourseRegistrationSettingsPayload: UpdateCourseStatusDTO | null = null;
  licenseFormHasError: boolean = false;
  seat: number = 0;

  isLicenseSeatConfirmationModalActive: boolean = false;
  isDisableCoursePackageModalActive: boolean = false;
  isCourseCancellationModalActive: boolean = false;

  template: CourseLicenseTemplateResponse | null = null;

  // -- COMPUTED MODAL PROPS --
  get LicenseExceedsCourseSizeConfirmationModal() {
    return LicenseExceedsCourseSizeConfirmationModal;
  }

  get DisableCoursePackagesModal() {
    return DisableCoursePackagesModal;
  }

  get CourseCancellationConfirmationModal() {
    return CourseCancellationConfirmationModal;
  }

  get confirmationModalProps() {
    return {
      onConfirmAndPublish: this.confirmLicenseAndPublish,
      licenseSeats: this.seat,
      courseSize: this.courseSize
    };
  }

  get disableCoursePackagesModalProps() {
    return {
      confirmDelete: this.confirmFreeCourseAndPublish,
      activeCoursePackageCount: this.pricedCoursePackageCount
    };
  }

  get courseCancellationModalProps() {
    return {
      confirmDelete: this.confirmCourseCancellation,
      courseName: this.groupDetail.name ?? ''
    };
  }

  // -- GENERIC COMPUTED PROPERTIES --
  get shouldDisableInputFields() {
    return this.generateCourseLicensePreviewFromTemplateApiState.loading;
  }

  get seatsExceedCourseSize() {
    return this.seat > this.courseSize;
  }

  get currentCourseStatus() {
    return;
  }

  get dateRange(): string {
    const formattedStartDate: string = formatDateTime(
      this.getAttributeValueByLabel('Start Date') as string
    );

    const formattedEndDate: string = formatDateTime(
      this.getAttributeValueByLabel('End Date') as string
    );

    const dates: string[] = [formattedStartDate, formattedEndDate];

    return dates.join(' - ');
  }

  get shouldDisableCancelCourse() {
    const currentDate = dayjs().toDate();
    const courseEndDate = dayjs(this.courseEndDate).toDate();

    return currentDate > courseEndDate;
  }

  get locationGLAValue() {
    return this.getAttributeValueByLabel(
      'Location'
    ) as GroupLevelAttributeOption[];
  }

  get locationType() {
    const locationTypeGLAOption = this.locationGLAValue.find(
      (option) => option.placeholder === 'Location Type' && option.value
    );

    return (locationTypeGLAOption?.value as LocationType) ?? 'Venue';
  }

  get hasExistingLicense() {
    if (this.groupDetail) {
      return !!this.groupDetail.license;
    }
  }

  get existingLicenseName() {
    if (this.groupDetail && this.groupDetail.license) {
      return this.groupDetail.license.name;
    }
  }

  get isRemote() {
    return this.locationType === LocationType.REMOTE;
  }

  get isVenue() {
    return this.locationType === LocationType.VENUE;
  }

  get isBothRemoteAndVenue() {
    return this.locationType === LocationType.BOTH;
  }

  get hasChangedValues() {
    if (this.isRegistrationSettings) {
      return (
        this.courseDetails.visibility !== this.localVisibility ||
        this.courseDetails.openForRegistration !==
          this.localOpenForRegistration ||
        this.courseDetails.groupRegistration !== this.localGroupRegistration ||
        this.courseDetails.requireRegistrationConfirmation !==
          this.localRequireRegistrationConfirmation ||
        this.courseDetails.hasQuestionnaire !== this.localEnableQuestionnaire ||
        this.courseDetails.isFreeCourse !== this.localFreeCourse
      );
    }

    return true;
  }

  get shouldShowMissingAttributeWarning() {
    return (
      !this.isRegistrationSettings &&
      this.hasMissingRequiredCourseLevelAttributes &&
      this.localVisibility === CourseVisibility.PUBLIC
    );
  }

  get courseRegistrationSettingsPayload(): UpdateCourseStatusDTO {
    return {
      // Registration settings can only be accessed for PUBLISHED course
      status: CourseStatus.PUBLISHED,
      visibility: this.localVisibility,
      openForRegistration: this.localOpenForRegistration,
      requireRegistrationConfirmation: this
        .localRequireRegistrationConfirmation,
      isFreeCourse: this.localFreeCourse,
      hasQuestionnaire: this.localEnableQuestionnaire,
      groupRegistration: this.localGroupRegistration
    };
  }

  // Helper to determine if in the specific license creation flow
  get isLicenseCreationFlow(): boolean {
    return (
      this.shouldCreateWithLicense &&
      !this.hasExistingLicense &&
      !!this.createCourseLicensePayload
    );
  }

  // -- MODAL PROP FUNCTIONS (for handling event emission on stacked modals) --
  confirmLicenseAndPublish() {
    if (
      this.localCourseRegistrationSettingsPayload &&
      this.createCourseLicensePayload
    ) {
      this.publishDraftCourse(
        this.localCourseRegistrationSettingsPayload,
        this.createCourseLicensePayload
      );
      this.closeModal();
    }
  }

  confirmFreeCourseAndPublish() {
    if (this.localCourseRegistrationSettingsPayload) {
      this.publishDraftCourse(this.localCourseRegistrationSettingsPayload);
      this.closeModal();
    }
  }

  confirmCourseCancellation() {
    const courseCancellationPayload: UpdateCourseStatusDTO = {
      status: CourseStatus.CANCELLED,
      visibility: CourseVisibility.PRIVATE,
      openForRegistration: false,
      requireRegistrationConfirmation: false,
      isFreeCourse: this.courseDetails.isFreeCourse,
      hasQuestionnaire: this.courseDetails.hasQuestionnaire,
      groupRegistration: this.courseDetails.groupRegistration
    };

    this.cancelCourse(courseCancellationPayload);
    this.closeModal();
  }

  openConfirmationModal(): void {
    this.isLicenseSeatConfirmationModalActive = true;
  }

  openDisableCoursePackagesModal(): void {
    this.isDisableCoursePackageModalActive = true;
  }

  openCourseCancellationConfirmationModal(): void {
    this.isCourseCancellationModalActive = true;
  }

  // -- GENERIC FUNCTIONS --
  getAttributeValueByLabel(label: string): AttributeValueType {
    return this.attributes.find(
      (attr) =>
        attr.label.trim().toLocaleLowerCase() ===
        label.trim().toLocaleLowerCase()
    )?.value!;
  }

  assignLocalSeatValue(valueFromForm: number) {
    this.seat = Number(valueFromForm);
  }

  shouldDisablePublishCourseButton(
    formHasError: boolean,
    createLicensePayload: CreateGroupLicenseRequestPayload
  ) {
    this.licenseFormHasError = formHasError;
    this.createCourseLicensePayload = createLicensePayload;
  }

  assignLocalProps() {
    this.localVisibility = this.visibility;
    this.localOpenForRegistration = this.openForRegistration;
    this.localRequireRegistrationConfirmation = this.requireRegistrationConfirmation;
    this.localGroupRegistration = this.groupRegistration;
    this.localEnableQuestionnaire = this.enableQuestionnaire;
    this.localFreeCourse = this.freeCourse;
  }

  assignLocationValues() {
    if (this.isRemote || this.isBothRemoteAndVenue) {
      this.link = this.locationGLAValue
        .find((option) => option.placeholder === 'Meeting Link')
        ?.value?.toLocaleString()!;
    }

    if (this.isVenue || this.isBothRemoteAndVenue) {
      const addressFields: GroupLevelAttributeOption[] = this.locationGLAValue.filter(
        (option) =>
          option.placeholder !== 'Meeting Link' &&
          option.placeholder !== 'Location Type'
      );

      this.venue = this.renderAddress(addressFields);
    }
  }

  renderAddress(addressFields: GroupLevelAttributeOption[]): string {
    return (
      addressFields
        .map((option) => option.value)
        .filter((value) => value)
        /* Value could be null or empty string. Display only the ones with content */
        .join(', ')
    );
  }

  displayDate(date: AttributeValueType): string {
    const displayDate = dayjs(date as string).toDate();
    return dayjs(displayDate).format('DD MMM YYYY h:mmA');
  }

  processPublishDraftCoursePayload(): void {
    // If not settings, do nothing
    if (!this.isSettings) {
      return;
    }

    // 1. Prep the payload
    this.localCourseRegistrationSettingsPayload = this.courseRegistrationSettingsPayload;

    // 2. Handle License Creation Flow
    if (this.isLicenseCreationFlow) {
      this.handleLicensePublishing();
      return;
    }

    // 4. Handle Free Course vs Packages Conflict
    if (
      this.localFreeCourse !== this.freeCourse &&
      this.activeCoursePackages.length > 0 &&
      this.hasPricedCoursePackages
    ) {
      this.openDisableCoursePackagesModal();
      return;
    }

    // 5. Standard Publish
    this.finalizePublish(this.localCourseRegistrationSettingsPayload);
  }

  processCancelCoursePayload(): void {
    // If not settings, do nothing
    if (!this.isSettings) {
      return;
    }

    this.openCourseCancellationConfirmationModal();
  }

  handleLicensePublishing(): void {
    if (this.seatsExceedCourseSize) {
      this.openConfirmationModal();
      return;
    }

    // Both payloads have been null-checked in main flow
    this.finalizePublish(
      this.localCourseRegistrationSettingsPayload!,
      this.createCourseLicensePayload!
    );
  }

  finalizePublish(
    statusPayload: UpdateCourseStatusDTO,
    licensePayload?: CreateGroupLicenseDTO
  ): void {
    this.publishDraftCourse(statusPayload, licensePayload);
    this.closeModal();
  }

  @Debounce(300)
  handleGeneratePreview() {
    if (!this.template || !this.groupDetail) {
      return;
    }

    const payload: CourseLicensePreviewRequestDTO = {
      courseLicenseTemplateId: this.template.id,
      courseId: +this.courseDetails.id
    };
    this.generateCourseLicensePreviewFromTemplate(payload);
  }

  closeModal() {
    this.$emit('close');
  }

  mounted() {
    this.assignLocationValues();
    this.assignLocalProps();
  }

  @Emit('cancelCourse')
  cancelCourse(updateCoursePayload: UpdateCourseStatusDTO) {
    return updateCoursePayload;
  }

  publishDraftCourse(
    updateCoursePayload: UpdateCourseStatusDTO,
    createLicensePayload?: CreateGroupLicenseDTO
  ) {
    return this.$emit(
      'publishDraftCourse',
      updateCoursePayload,
      createLicensePayload
    );
  }

  @Emit('createAndPublishCourse')
  createAndPublishCourse(registrationConfigPayload: CourseRegistrationConfig) {
    return registrationConfigPayload;
  }

  @Watch('template')
  onTemplateSelected() {
    this.handleGeneratePreview();
  }
}
